// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3621":"15f38bf1187aae67","4381":"7f6afb1decfea637","4759":"c3501948f1995b29","7469":"983dc5e80d3298eb","8662":"5d2d376d9b37854a","9058":"348d573fc9e3a076","9228":"c4ffa92f3be308d8","9625":"9b7ec6d73c6846cb"}[chunkId] + ".js";
};